import { useEffect, useState } from "react";
import { MFButton } from "../../../../common/components/MFButton";
import MFModal from "../../../../common/containers/MFModal";
import { Folder } from "../../../../assets/icons/Folder";
import { Add } from "../../../../assets/icons/Add";
import { ModalManageFolder } from "./ModalManageFolder";
import { AlertCircle } from "../../../../assets/icons/AlertCircle";
import SearchInput from "../../../../common/components/SearchInput";

export function ModalAssignCalculToFolders({
  isOpen,
  onClose,
  allFolders,
  loadAllUserFolders,
  createFolder,
  manageCalculsFolders,
  calculIds,
  calculFolders,
  loadUserCalculs,
  loadFolderCalculs,
  folderId,
}) {
  const [search, setSearch] = useState("");
  const [filteredFolders, setFilteredFolders] = useState(allFolders || []);
  const [isManageFolderModalOpen, setIsManageFolderModalOpen] = useState(false);
  const isMultiple = calculIds.length > 1;
  const [selectedFolders, setSelectedFolders] = useState(
    isMultiple ? [] : calculFolders || [],
  );
  const [unselectedFolders, setUnselectedFolders] = useState([]);

  useEffect(() => {
    setFilteredFolders(
      allFolders.filter((folder) =>
        folder.label.toLowerCase().includes(search.toLowerCase()),
      ),
    );
  }, [search, allFolders]);

  useEffect(() => {
    if (isOpen) {
      setSelectedFolders(isMultiple ? [] : calculFolders || []);
      loadAllUserFolders();
    }
  }, [loadAllUserFolders, isOpen]); // eslint-disable-line

  const handleCloseManageFolderModal = () => {
    setIsManageFolderModalOpen(false);
    loadAllUserFolders();
  };

  const handleSelectFolder = (id) => () => {
    const isInCalculFolders = calculFolders?.includes(id);
    const isSelected = selectedFolders.includes(id);
    const isUnselected = unselectedFolders.includes(id);

    if (isInCalculFolders) {
      if (!isSelected && !isUnselected) {
        setSelectedFolders((prev) => [...prev, id]);
      } else if (isSelected) {
        setSelectedFolders((prev) => prev.filter((f) => f !== id));
        setUnselectedFolders((prev) => [...prev, id]);
      } else {
        setUnselectedFolders((prev) => prev.filter((f) => f !== id));
      }
    } else {
      if (isSelected) {
        setSelectedFolders((prev) => prev.filter((f) => f !== id));
      } else {
        setSelectedFolders((prev) => [...prev, id]);
      }
    }
  };

  const handleValidate = () => {
    if (unselectedFolders.length > 0) {
      manageCalculsFolders({
        userFdesIds: calculIds,
        folderIds: unselectedFolders,
        action: "remove",
      });
    }
    if (selectedFolders.length > 0) {
      manageCalculsFolders({
        userFdesIds: calculIds,
        folderIds: selectedFolders,
        action: "add",
      });
    }
    setTimeout(() => {
      if (folderId) {
        loadFolderCalculs(folderId);
      } else {
        loadUserCalculs();
      }
      setUnselectedFolders([]);
      onClose();
    }, 500);
  };

  return !isManageFolderModalOpen ? (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="folder-modal-container"
    >
      <p className="modal-title text-center">Ajouter à un dossier</p>
      <p className="modal-text text-center" style={{ marginBottom: "24px" }}>
        Sélectionnez les dossiers ou créez-en un nouveau
      </p>
      <SearchInput
        search={search}
        setSearch={setSearch}
        placeholder="Rechercher un dossier"
        containerStyle={{ marginBottom: 24 }}
      />
      <div
        style={{
          maxHeight: unselectedFolders.length > 0 ? 310 : 400,
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {filteredFolders.map((folder) => (
          <label
            key={folder._id}
            className="d-flex align-items-center justify-content-between label-folder-checkbox"
            style={{ padding: 10, borderRadius: 6 }}
          >
            <div className="d-flex align-items-center mr-1">
              <div className="folder-table-icon mr-1">
                <Folder size={24} />
              </div>
              {folder.label}
            </div>
            <div>
              <input
                checked={
                  (selectedFolders.includes(folder._id) ||
                    calculFolders?.includes(folder._id)) &&
                  !unselectedFolders.includes(folder._id)
                }
                onChange={handleSelectFolder(folder._id)}
                type="checkbox"
                value={selectedFolders.includes(folder._id)}
                className={`checkbox-primary ${calculFolders?.includes(folder._id) && !selectedFolders.includes(folder._id) ? "checkbox-already-in-folder" : ""}`}
              />
            </div>
          </label>
        ))}
      </div>

      {filteredFolders.length === 0 && (
        <div className="error-div">
          <div className="error-logo">
            <AlertCircle size={22} />
          </div>
          Pas de résultat correspondant.
          <br />
          Veuillez reformuler votre recherche.
        </div>
      )}

      <MFButton
        height={30}
        style={{ marginTop: 24 }}
        onClick={() => setIsManageFolderModalOpen(true)}
      >
        <span className="d-flex justify-content-center">
          <Add size={14} />{" "}
          <span style={{ marginLeft: 5 }}>Nouveau dossier</span>
        </span>
      </MFButton>
      {unselectedFolders.length > 0 && (
        <div className="error-div" style={{ marginTop: 24 }}>
          <div className="error-logo">
            <AlertCircle size={22} />
          </div>
          {isMultiple
            ? "En validant, vos calculs seront retirés des dossiers où ils étaient présents."
            : "En validant, votre calcul sera retiré des dossiers où il était présent."}
        </div>
      )}
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="d-flex align-items-center justify-content-center mt-4">
          <MFButton
            style={{ fontSize: 15 }}
            className="mr-1"
            onClick={handleValidate}
            disabled={
              selectedFolders.length === 0 && unselectedFolders.length === 0
            }
          >
            Valider
          </MFButton>
          <MFButton style={{ fontSize: 15 }} cancelButton onClick={onClose}>
            Annuler
          </MFButton>
        </div>
      </form>
    </MFModal>
  ) : (
    <ModalManageFolder
      isOpen={isManageFolderModalOpen}
      onClose={handleCloseManageFolderModal}
      createFolder={createFolder}
    />
  );
}
